import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

export default function mobileSwitch(DesktopComponent, MobileComponent) {
  class MobileSwitch extends React.Component {
    render() {
      return this.props.isMobile ? <MobileComponent {...this.props}/> : <DesktopComponent {...this.props}/>;
    }
  }

  MobileSwitch.displayName = 'MobileSwitch';
  MobileSwitch.propTypes = {
    isMobile: PropTypes.bool
  };

  return connect(state => ({isMobile: state.init.isMobile}))(MobileSwitch);
}



// WEBPACK FOOTER //
// ./containers/MobileSwitch/MobileSwitch.js